import { useMemo, useContext } from "react";
import { CLOTHING_CUSTOM_SCAN, CLOTHING_BANNER_SCAN, CLOTHING_CUSTOM_FIT_SCAN } from "../vars";
import { UserDetailsContext } from "../context/userDetails";

export default function useIsCustom() {
  const { scanType } = useContext(UserDetailsContext);
  return useMemo(
    () => [CLOTHING_CUSTOM_SCAN, CLOTHING_BANNER_SCAN, CLOTHING_CUSTOM_FIT_SCAN].includes(scanType),
    [scanType]
  );
}